module.exports = __webpack_public_path__ + "static/img/banner_support_01.d64ea12.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/banner_support_01.png
// module id = SBYj
// module chunks = 10